const zh = {
  title: "中医药大模型知识图谱智能问答系统",
  intro: "简介",
  print: "打印",
  send: "发送",
  inputPlaceholder: "请输入问题",
  voiceInput: "语音输入",
  clearMessage: "清空聊天记录和图谱",
  cancel: "取消",
  confirm: "确定",
  text: "中医药大模型知识图谱智能问答系统利用大语言模型和知识图谱等人工智能新技术，实现中医药专业知识的智能问答，能够根据用户描述的症状进行中医药方剂智能推荐，形成中医药专业知识智能专家系统。",
  ref: "参考",
};
export default zh;
